import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, addDoc, getDocs, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { FaTrash, FaPlus, FaEdit, FaLock } from 'react-icons/fa';

export default function Instruments() {
  const [instruments, setInstruments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editId, setEditId] = useState(null);

  const instrumentsRef = collection(db, "instruments");
  
  // === LISTA DE FUNÇÕES PROTEGIDAS ===
  const PROTECTED_ROLES = ["Ministro de Música", "Vocal"];

  const getInstruments = async () => {
    setLoading(true);
    try {
      const data = await getDocs(instrumentsRef);
      const list = data.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      
      // === LÓGICA DE AUTO-CRIAÇÃO MÚLTIPLA ===
      let created = false;
      for (const role of PROTECTED_ROLES) {
          if (!list.some(i => i.name === role)) {
              await addDoc(instrumentsRef, { name: role });
              created = true;
          }
      }
      
      if (created) {
          // Recarrega se criou algo novo
          const newData = await getDocs(instrumentsRef);
          const newList = newData.docs.map(doc => ({ ...doc.data(), id: doc.id }));
          newList.sort((a, b) => a.name.localeCompare(b.name));
          setInstruments(newList);
      } else {
          list.sort((a, b) => a.name.localeCompare(b.name));
          setInstruments(list);
      }
    } catch (error) {
      console.error("Erro ao buscar:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getInstruments();
  }, []);

  const handleEdit = (inst) => {
    if (PROTECTED_ROLES.includes(inst.name)) {
        alert(`"${inst.name}" é um item padrão do sistema e não pode ser editado.`);
        return;
    }
    setName(inst.name);
    setEditId(inst.id);
    setIsFormOpen(true);
  };

  const handleCancel = () => {
    setName(''); setEditId(null); setIsFormOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) return;

    // Evita criar duplicado manual dos protegidos
    if (PROTECTED_ROLES.includes(name) && !editId) {
        alert("Este instrumento já existe como padrão.");
        return;
    }

    try {
      if (editId) {
        await updateDoc(doc(db, "instruments", editId), { name });
      } else {
        await addDoc(instrumentsRef, { name });
      }
      handleCancel();
      getInstruments();
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  };

  const handleDelete = async (inst) => {
    // === PROTEÇÃO DE EXCLUSÃO ===
    if (PROTECTED_ROLES.includes(inst.name)) {
        alert(`"${inst.name}" é essencial para a lógica do sistema e não pode ser excluído.`);
        return;
    }

    if (window.confirm("Excluir este instrumento?")) {
      await deleteDoc(doc(db, "instruments", inst.id));
      getInstruments();
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Instrumentos</h1>
        <button 
          onClick={() => { if(isFormOpen) handleCancel(); else setIsFormOpen(true); }}
          className="bg-brand-blue text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-800 transition"
        >
          <FaPlus />
          <span className="hidden sm:inline">{isFormOpen ? 'Cancelar' : 'Novo Instrumento'}</span>
        </button>
      </div>

      {isFormOpen && (
        <div className="bg-white p-6 rounded-lg shadow-md mb-6 border-l-4 border-brand-gold animate-fade-in">
          <h3 className="text-lg font-bold mb-3 text-gray-700">{editId ? 'Editar' : 'Novo'}</h3>
          <form onSubmit={handleSubmit} className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="block text-sm font-bold text-gray-600 mb-1">Nome</label>
              <input value={name} onChange={(e) => setName(e.target.value)} className="w-full border p-2 rounded focus:border-brand-blue outline-none" required />
            </div>
            <button type="submit" className="bg-brand-gold text-brand-blue font-bold px-6 py-2 rounded hover:opacity-90 h-10">
              {editId ? 'Atualizar' : 'Salvar'}
            </button>
          </form>
        </div>
      )}

      {loading ? <div className="text-center p-10 text-gray-500">Carregando...</div> : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {instruments.map((inst) => (
            <div key={inst.id} className={`bg-white p-4 rounded shadow flex justify-between items-center border-l-4 transition ${PROTECTED_ROLES.includes(inst.name) ? 'border-gray-400 bg-gray-50' : 'border-brand-blue hover:bg-gray-50'}`}>
              <span className="font-bold text-gray-700">{inst.name}</span>
              <div className="flex gap-2">
                {PROTECTED_ROLES.includes(inst.name) ? (
                    <FaLock className="text-gray-400" title="Item Protegido" />
                ) : (
                    <>
                        <button onClick={() => handleEdit(inst)} className="text-blue-400 hover:text-blue-600"><FaEdit /></button>
                        <button onClick={() => handleDelete(inst)} className="text-red-300 hover:text-red-600"><FaTrash /></button>
                    </>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}